import React from 'react';
import { reportError } from '@this/src/lib/bugsnag';
import NationalityList from './nationalities_list';
import { styled } from '../../constants/themes';
import {
  WorkflowSelectorArrow,
  WORKFLOW_SELECTOR_BORDER_COLOR,
  workflowSelectorTriggerCss
} from '../workflow_selector_appearance';

interface Props {
  selectedId?: number;
  nationalities: { id: number; name: string }[];
  onSelect?: (id: number) => void;
  dataTestIdPrefix?: string;
  fullWidth?: boolean;
}

interface State {
  showNationalityList: boolean;
  selectedNationalities: { id: number; name: string }[];
}

class SelectNationalities extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      showNationalityList: false,
      selectedNationalities: []
    };

    this.toggleNationalityList = this.toggleNationalityList.bind(this);
    this.handleNationalitySelect = this.handleNationalitySelect.bind(this);
  }

  handleNationalitySelect(id: number) {
    this.setState({
      showNationalityList: false
    });
    if (this.props.onSelect) {
      this.props.onSelect(id);
    }
  }

  toggleNationalityList(e: React.MouseEvent<HTMLElement>) {
    e.preventDefault();
    this.setState({
      showNationalityList: !this.state.showNationalityList
    });
  }

  render() {
    const rawNationalities: { id: number; name: string }[] = this.props.nationalities;
    const selectedNatioNality: { id: number; name: string } | undefined = rawNationalities.find(
      nationality => nationality.id === this.props.selectedId
    );
    try {
      return (
        <SelectNationalityWrapper $fullWidth={this.props.fullWidth}>
          <SelectedListItem
            $open={this.state.showNationalityList}
            data-testid={this.props.dataTestIdPrefix ? `${this.props.dataTestIdPrefix}-selected` : undefined}
            onClick={this.toggleNationalityList}
          >
            {selectedNatioNality ? (
              <ListItemInfo>
                <ItemPart>{selectedNatioNality.name}</ItemPart>
              </ListItemInfo>
            ) : (
              <ItemMessage>-</ItemMessage>
            )}
            <WorkflowSelectorArrow open={this.state.showNationalityList} />
          </SelectedListItem>
          {this.state.showNationalityList && (
            <div>
              <NationalityList
                {...this.props}
                nationalities={this.props.nationalities}
                selectedNationalities={this.state.selectedNationalities}
                onSelect={this.handleNationalitySelect}
              />
            </div>
          )}
        </SelectNationalityWrapper>
      );
    } catch (e) {
      reportError(e);
      return null;
    }
  }
}

const SelectNationalityWrapper = styled.div<{ $fullWidth?: boolean }>`
  font-size: 13px;
  min-width: ${props => (props.$fullWidth ? '0' : '263px')};
  width: ${props => (props.$fullWidth ? '100%' : 'auto')};
  flex: ${props => (props.$fullWidth ? '1' : 'none')};
  background-color: #ffffff;
`;

const SelectedListItem = styled.div<{ $open?: boolean }>`
  ${workflowSelectorTriggerCss};
  width: 100%;
  border-color: ${props => (props.$open ? props.theme.linkColor : WORKFLOW_SELECTOR_BORDER_COLOR)};
`;

const ListItemInfo = styled.div`
  display: flex;
  flex: 1;
  flex-wrap: wrap;
  min-width: 0;
`;

const ItemPart = styled.p`
  margin-right: 5px;
  display: inline-block;
`;

const ItemMessage = styled.p`
  color: #292929;
  flex: 1;
  min-width: 0;
`;

export default SelectNationalities;
